<template>
  <grid ref="grid" :config="gridConfig" class="no-grid-border"/>
</template>

<script>
import gridConfig from './GridConfig.json'
import { waitValue } from '@/utils/promises'

export default {
  name: 'StocksParts',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  props: {
    aircraftID: { required: true }
  },
  watch: {
    aircraftID: {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            if (this.aircraftID) {
              grid.model.store.get.filters = `aircraftID == ${this.aircraftID}`
              grid.loadData()
            }
          })
      }
    }
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    }
  }
}
</script>
